const DAY = 86400000;
export function shiftAnalyticsDate(date: string, days: number): string {
  const value = new Date(`${date}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(value.getTime()) || value.toISOString().slice(0,10)!==date || !Number.isInteger(days)) throw new Error('Invalid analytics date');
  return new Date(value.getTime()+days*DAY).toISOString().slice(0,10);
}
export function analyticsLastDays(days:number,timeZone:string,now=new Date()) {
  if(!Number.isInteger(days)||days<1||days>3660)throw new Error('Invalid analytics period');
  const endDate=new Intl.DateTimeFormat('en-CA',{timeZone,year:'numeric',month:'2-digit',day:'2-digit'}).format(now);
  return {startDate:shiftAnalyticsDate(endDate,1-days),endDate};
}
export function analyticsComparisonPeriod(startDate:string,endDate:string) {
  shiftAnalyticsDate(startDate,0);shiftAnalyticsDate(endDate,0);
  if(startDate>endDate)throw new Error('Invalid analytics period');
  const days=(Date.parse(`${endDate}T00:00:00Z`)-Date.parse(`${startDate}T00:00:00Z`))/DAY+1;
  return {comparisonStartDate:shiftAnalyticsDate(startDate,-days),comparisonEndDate:shiftAnalyticsDate(startDate,-1)};
}
